import React, { Component } from 'react';
import classNames from 'classnames';
import { PaddedSection, SimpleMarkdown } from '../../atoms';

import './styles.css';

/**
 * A template for the hero section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {String} topHeading
 * @prop {String} heading
 * @prop {String} subheading

 * @augments {Component<Props>}
 */
export default class HubHero extends Component {

	genClassName = (props) => classNames('HubHero', props.className);

	render () {
		const { heading, subheading, topHeading } = this.props;
		const className = this.genClassName(this.props);
		return (
			<PaddedSection
				className={className}
			>
				<div className='hero-top-bg' />
				<h2>{topHeading}</h2>
				<SimpleMarkdown extended>{heading}</SimpleMarkdown>
				<h3>{subheading}</h3>
				<div className='hero-bottom-bg' />
			</PaddedSection>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/templates/HubHero/HubHero.js